import slugify from "slugify";
import { useSelector } from "react-redux";
import { updateMetadata, uploadFile } from "../../../utils/storage";
import { getImageDimensions } from "../../../utils/utils";
import { getFileUrl } from "../../../utils/api";
import UploadFileButton from "../../../components/UploadFileButton/UploadFileButton";

const isImage = (file) => {
  var idxDot = file.lastIndexOf(".") + 1;
  var extFile = file.substr(idxDot, file.length).toLowerCase();
  return /(jpe?g|png)$/i.test(extFile);
};

const UploadFile = (props) => {
  const { orgData } = useSelector((state) => state.orgData);
  const { setImages } = props;
  const orgId = orgData.org.orgId;
  const activityId = orgData.activities.activityId;

  const newFileHandler = async (e) => {
    const originalFile = e.target.files[0];

    // Validate image type first using original name
    if (!isImage(originalFile.name)) {
      alert("Only PNG and JPG images are supported");
      return;
    }

    const sanitizedFileName = `${Date.now()}_${slugify(originalFile.name, { lower: true })}`;
    const file = new File([originalFile], sanitizedFileName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    });

    let imgDimensions;

    // Get image dimensions
    try {
      const { width, height } = await getImageDimensions(URL.createObjectURL(originalFile));
      imgDimensions = `${width} x ${height} px`;
    } catch (err) {
      console.error("Error getting image dimensions:", err);
    }

    // Add loading entry with original name
    setImages((state) => [
      ...state,
      {
        title: originalFile.name,
        dimensions: imgDimensions,
        isLoading: true,
      },
    ]);

    // Upload file
    getFileUrl(orgId, activityId, file.name).then((data) => {
      uploadFile(file, data.url + data.sas_token).then(() => {
        updateMetadata(file, data.url + data.sas_token, "dimensions", imgDimensions).then(() => {
          setImages((state) => {
            const updated = [...state];
            const uploadedFile = updated.find((i) => i.title === originalFile.name && i.isLoading);
            if (uploadedFile) {
              uploadedFile.url = data.url;
              uploadedFile.isLoading = false;
            }
            return updated;
          });
        });
      });
    });
  };

  return (
    <UploadFileButton
      onUpload={newFileHandler}
      title="Add background photo"
      accept="image/png, image/jpg, image/jpeg"
    />
  );
};

export default UploadFile;
